import Phaser from 'phaser';
import { createPremiumMissionMap } from '../systems/PremiumMissionMap';
import { ProgressData as PlayerData } from '../systems/ProgressData';
import { GAME_MODE, getGameMode } from '../systems/GameMode';
import { formatScore } from '../util/numberFormat';
import { SUMA_MISSIONS, CHALLENGES_PER_MISSION } from '../planets/additionMissions';
import { mountMenu, element, button, header, modeBadge, go } from '../util/menuUI';

export class SumaMissionsScene extends Phaser.Scene {
  constructor() { super('SumaMissionsScene'); }

  create() {
    const root = mountMenu(this);
    root.classList.add('tmag-mission-map', 'tmag-suma');
    const isPractice = getGameMode(this.registry) === GAME_MODE.PRACTICE;
    if (isPractice) root.classList.add('tmag-practice-map');
    const done = PlayerData.countMissionsComplete('suma', SUMA_MISSIONS.length);
    header(
      root,
      'SISTEMA ESTELAR DE LA SUMA',
      isPractice ? 'Elige un planeta para practicar' : `Elige un planeta para explorar · ${done} / ${SUMA_MISSIONS.length} completados`,
      '← GALAXIA',
      () => go(this, 'GalaxyScene'),
    );
    root.querySelector('.tmag-menu-header')?.append(modeBadge(this));

    const premium = createPremiumMissionMap(this, root);
    const grid = element('div', 'tmag-grid');
    SUMA_MISSIONS.forEach(m => {
      const unlocked = isPractice || PlayerData.isMissionUnlocked('suma', m.index);
      const complete = !isPractice && PlayerData.isMissionComplete('suma', m.index);
      const attempted = !isPractice && !!PlayerData.getMissionAttempt('suma', m.index);
      const card = button('', () => {
        if (premium.guard(card, m.index)) return;
        go(this, 'MissionScene', () => {
        this.registry.set('currentPlanet', 'suma');
        this.registry.set('currentMissionIndex', m.index);
        this.registry.set('currentMissionData', m);
        this.registry.get('audio')?.playCollect();
        });
      }, `tmag-card${complete ? ' tmag-complete' : ''}`);
      card.disabled = !unlocked;

      card.append(element('h2', '', `PLANETA ${m.num}`));
      card.append(element('p', 'tmag-skill', m.skill));
      if (!isPractice) {
        card.append(element('span', 'tmag-card-info', `${CHALLENGES_PER_MISSION} retos de suma`));
        const best = PlayerData.getMissionBest('suma', m.index);
        card.append(element('span', 'tmag-card-info', best ? `★ Mejor: ${formatScore(best)} pts` : '★ Mejor: —'));
        card.append(element('span', 'tmag-status', complete ? '✓ DOMINADA' : unlocked ? attempted ? '↻ PRACTICAR' : 'DISPONIBLE' : '🔒 BLOQUEADA'));
      }
      const status = card.querySelector('.tmag-status') || element('span', 'tmag-status', 'DISPONIBLE');
      if (!status.isConnected) card.append(status);
      premium.register(card, m.index, unlocked, status);
      grid.append(card);
    });
    root.append(grid);
  }
}
